import * as React from "react";
import { Stack, Columns, Column } from "@origin-digital/ods-core";
import { Heading4, Text } from "@origin-digital/style-guide";

interface IChatItemProps {
  dataId: string;
  title: string;
  icon: React.ReactNode;
  body: string;
  extra?: React.ReactNode;
}

export const ChatItem = ({
  dataId,
  title,
  icon,
  body,
}: IChatItemProps): JSX.Element => {
  return (
    <Stack data-id={`chat-item-${dataId}`} space="medium">
      <Columns space="small">
        <Column width="content">{icon}</Column>
        <Column width="flex">
          <Heading4 text={title} />
        </Column>
      </Columns>
      <Text markdown={true}>{body}</Text>
    </Stack>
  );
};
